module.exports = __webpack_public_path__ + "img/charging-station-hyper-fast-mobile.f4bf9661.png";